module.exports = __webpack_public_path__ + "static/img/nuevos_06.f032bff0.jpg";